import { EpicRefined } from 'interfaces/middleware'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { GetMeetingVideoDetailsAction, AdvisorVideoCallActions } from 'components/features/coaching/advisorVideoCall/types/actions'
import { mergeMap, map, delay, takeUntil, catchError } from 'rxjs/operators'
import { GET_MEETING_VIDEO_DETAILS_URL } from 'interfaces/ajax'
import { catchAjaxSafe } from 'rxOperators/catchSafe'
import { of, merge } from 'rxjs'
import { setUnexpectedErrorActionCreator } from 'actions/globalActions'
import { getTokenHeader } from 'components/features/coaching/advisorVideoCall/helpers'
import { UNAUTHORIZED_STATUS_CODE, NOT_FOUND_STATUS_CODE } from 'constants/ajax'
import { pushActionCreator } from 'actions/navigationActions'
import { LOGIN_URL } from 'tangle-shared'

export const getMeetingVideoDetailsEpic: EpicRefined<AdvisorVideoCallActions> = (action$, _, { get }) => action$.pipe(
  filterRequestOfType(GetMeetingVideoDetailsAction.type, 'request'),
  mergeMap((action) => {
    const { params } = action.payload

    const url = {
      url: GET_MEETING_VIDEO_DETAILS_URL,
      params: {
        meeting_uid: params.meetingId,
      },
    }

    return get(url, undefined, getTokenHeader()).pipe(
      map(({ response }) => action.success(response)),
      mergeMap((nextAction) => {
        const { response } = nextAction.payload
        const { video } = response
        const connection = video?.connection ?? null

        if (!!video && !connection) {
          return merge(
            of(nextAction),
            of(null).pipe(
              takeUntil(
                action$.pipe(
                  filterRequestOfType(GetMeetingVideoDetailsAction.type, 'request'),
                )
              ),
              delay(new Date(video.start_time)),
              map(() => new GetMeetingVideoDetailsAction(params))
            )
          )
        }

        return of(nextAction)
      }),
      catchError((error) => {
        const failAction = action.fail({ errorCode: error.status })
        if (error.status === UNAUTHORIZED_STATUS_CODE) {

          return merge(
            of(failAction),
            of(pushActionCreator(LOGIN_URL)),
          )
        }
        if (error.status === NOT_FOUND_STATUS_CODE) {
          return merge(
            of(failAction),
            of(setUnexpectedErrorActionCreator('page-not-found')),
          )
        }
        throw error
      }),
      catchAjaxSafe((error) => of(action.fail({ errorCode: error.status }))),
      map((nextAction) => nextAction as any as AdvisorVideoCallActions)
    )
  }),
)
